import { render, staticRenderFns } from "./ForumListGroup.vue?vue&type=template&id=3c28aee8&scoped=true"
import script from "./ForumListGroup.vue?vue&type=script&lang=ts"
export * from "./ForumListGroup.vue?vue&type=script&lang=ts"
import style0 from "./ForumListGroup.vue?vue&type=style&index=0&id=3c28aee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28aee8",
  null
  
)

export default component.exports